<script>
import MottoIcon from '@components/motto-icon.vue'
import ResourcePreviewFile from '@components/resources/resource-preview-file.vue'
import { downloadResourceAssetMixin } from '@src/mixins/downloadResourceAssetMixin'
import { resourcesComputed } from '@state/helpers'

export default {
  components: {
    MottoIcon,
    ResourcePreviewFile,
  },
  mixins: [downloadResourceAssetMixin],
  props: {
    resource: {
      type: Object,
      required: true,
    },
    modalButton: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...resourcesComputed,
    downloadLabel() {
      if (
        this.resource.resourceType === 'package' &&
        this.resource.relatedResources.filter((r) => r.isDownloadable).length
      ) {
        return 'Download All'
      }
      return 'Download'
    },
  },
}
</script>

<template>
  <div v-if="resource.isDownloadable">
    <ResourcePreviewFile :resource="resource" @click="downloadResourceAsset(resource)" />
    <BaseButton
      :class="{
        [$style.downloadButton]: true,
        [$style.pageButton]: !modalButton,
        [$style.modalButton]: modalButton,
      }"
      theme="white"
      @click="downloadResourceAsset(resource)">
      <MottoIcon name="Download" icon-color="gray" />
      <p class="button-text color-dark-gray">{{ downloadLabel }}</p>
    </BaseButton>
  </div>
</template>

<style lang="scss" module>
@import '@design';

.downloadButton {
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    margin-right: 13px;
  }
}

.pageButton {
  @media (max-width: $lg-breakpoint) {
    margin-left: 40px;
  }

  width: 231px;
  height: 40px;
  margin-top: 25px;
  margin-left: 85px;
}

.modalButton {
  width: 100%;
  margin-top: 32px;
}
</style>
